// Central data file: products, brands, gallery, company
// Product images are served from /public/images/products (user-uploaded originals).

export const COMPANY = {
  name: "Kashetter Industrial Essentials",
  tagline: "Industrial Spares & Power Transmission Solutions",
  proprietor: "Kashetter K E",
  address: "574/2, Aishwaraya Tower, Near Tyre Shops, Lawyers Street, Davangere, Karnataka",
  phone: "+91 94481 34454",
  phoneHref: "tel:+919448134454",
  whatsapp: "https://wa.me/919448134454",
  email: "kashetter@gmail.com",
  emailHref: "mailto:kashetter@gmail.com",
  instagram: "https://instagram.com/",
  facebook: "https://facebook.com/",
  mapsEmbed:
    "https://www.google.com/maps?q=Lawyers+Street+Davangere&output=embed",
  yearsExperience: 25,
  citiesServed: 120,
  productLines: 21,
};

export const BRANDS = [
  { name: "SKF", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/SKF_logo.svg/320px-SKF_logo.svg.png", category: "Bearings" },
  { name: "FAG", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/FAG_logo.svg/320px-FAG_logo.svg.png", category: "Bearings" },
  { name: "NTN", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/NTN_Corporation_logo.svg/320px-NTN_Corporation_logo.svg.png", category: "Bearings" },
  { name: "TIMKEN", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Timken_company_logo.svg/320px-Timken_company_logo.svg.png", category: "Bearings" },
  { name: "NBC", logo: "https://upload.wikimedia.org/wikipedia/en/thumb/5/57/NBC_Bearings_logo.png/320px-NBC_Bearings_logo.png", category: "Bearings" },
  { name: "ZKL", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/ZKL_Group_logo.svg/320px-ZKL_Group_logo.svg.png", category: "Bearings" },
  { name: "URB", logo: "https://www.urbgroup.com/wp-content/uploads/2019/02/logo.png", category: "Bearings" },
  { name: "FKRS", logo: "", category: "Bearings" },
  { name: "Fenner", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Fenner_logo.svg/320px-Fenner_logo.svg.png", category: "V-Belts" },
  { name: "PIX", logo: "https://www.pixtrans.com/images/PIX-Logo.png", category: "V-Belts" },
  { name: "KIE-Powerdrive", logo: "https://www.powerdrive.com/Images/Logo.png", category: "Gear Box" },
  { name: "OMFA", logo: "", category: "V-Belts" },
  { name: "Endura", logo: "", category: "V-Belts" },
  { name: "VITON", logo: "", category: "Oil Seals" },
  { name: "Rajhans", logo: "", category: "Oil Seals" },
];

const IMG = "/images/products";

export const PRODUCTS = [
  {
    slug: "conveyor-belts",
    name: "Conveyor Belts",
    short: "Heavy-duty rubber conveyor belts for mining, quarry & bulk handling",
    image: `${IMG}/conveyor-belts.jpg`,
    description:
      "Premium multi-ply rubber conveyor belts engineered for crushers, mining, cement, sugar and bulk material handling. Available in EP, NN and Steel cord constructions with grade-M24, N17 and heat / oil / fire-resistant covers.",
    specs: [
      "Width: 400 mm – 2000 mm",
      "Plies: 2 to 6 ply (EP/NN)",
      "Cover Grades: M24, N17, HR, FR, OR",
      "Top Cover: 3 mm – 10 mm",
      "Tensile strength up to 1250 N/mm",
    ],
    tags: ["Mining", "Crusher", "Bulk Handling"],
  },
  {
    slug: "idler-rollers",
    name: "Idler Rollers",
    short: "Carrying, return, impact and self-aligning idler rollers",
    image: `${IMG}/idler-rollers.jpg`,
    description:
      "Precision-engineered conveyor idler rollers — carrying, return, impact, training and self-aligning types — built with sealed bearings for long, maintenance-free service in dusty crusher environments.",
    specs: ["Diameters: 89, 102, 108, 127, 152 mm", "Shell: ERW MS / SS", "Sealed-for-life bearings", "Static balanced", "Optional rubber discs / impact"],
    tags: ["Crushers", "Conveyors"],
  },
  {
    slug: "drums-rubber-lagging",
    name: "Drums with Rubber Lagging",
    short: "Drive, snub, take-up & bend pulleys with diamond / plain lagging",
    image: `${IMG}/drums-rubber-lagging.jpg`,
    description:
      "Conveyor drum pulleys (drive, tail, snub, bend, take-up) with vulcanised diamond-grooved or plain rubber lagging for higher friction grip and longer belt life. Supplied with locking assemblies.",
    specs: ["Diameter: 200 – 1250 mm", "Lagging: 8/10/12/15 mm", "Pattern: Diamond / Herringbone / Plain", "Shell + end-disc fabrication", "Dynamic balanced"],
    tags: ["Drive Pulley", "Lagging"],
  },
  {
    slug: "jaw-plates",
    name: "Jaw Plates",
    short: "High manganese steel jaw crusher wear plates",
    image: `${IMG}/jaw-plates-cone-mantles.jpg`,
    description:
      "Genuine and replacement jaw plates (fixed & swing) cast in Mn14% / Mn18% / Mn21% high manganese steel. Composite Mn13Cr2 / Mn18Cr2 grades available. Compatible with all leading Indian and imported jaw crushers — corrugated and smooth tooth profiles.",
    specs: ["Material: Mn14 / Mn18 / Mn21 / Composite Mn-Cr", "Hardness: 190-220 BHN (work-hardens to 550)", "Tooth profile: corrugated / smooth", "Custom castings on order", "Annealed for higher toughness"],
    tags: ["Jaw Crusher", "Wear Parts"],
  },
  {
    slug: "cone-mantles",
    name: "Cone Mantles & Concaves",
    short: "Mantles, concaves and bowl liners for cone & gyratory crushers",
    image: `${IMG}/cone-mantles.jpg`,
    description:
      "Premium-grade cone mantles, concaves and bowl liners cast in Mn14% / Mn18% / Mn21% manganese steel. Compatible with Symons, HP, GP, CH/CS series and other leading cone & gyratory crushers. Custom castings supplied to drawing on order.",
    specs: ["Material: Mn14 / Mn18 / Mn21 manganese steel", "Profiles: standard, medium, fine", "Sizes: 2ft, 3ft, 4¼ft, 5½ft, 7ft Symons + HP/GP series", "OEM-equivalent profiles", "Heat-treated and quality tested"],
    tags: ["Cone Crusher", "Mantle", "Concave"],
  },
  {
    slug: "vsi-spares",
    name: "VSI Spares",
    short: "Premium-grade wear & spare parts for vertical shaft impactors",
    image: `${IMG}/vsi-spares.jpg`,
    description:
      "A complete range of made-in-India VSI crusher wear and spare parts — engineered to match or exceed OEM fit, material grade and performance. We stock rotor tips (tungsten carbide), distributor plates, cascade rings, anvils (manganese & ceramic), wear plates, feed tubes, side liners and rotor assemblies. Compatible with leading vertical-shaft impactors including Barmac, Terex, Sandvik CV, Metso, Swedala Merlin and other popular brands.",
    specs: [
      "Compatible: Barmac, Terex, Sandvik CV, Metso, Swedala Merlin",
      "Rotor tips: tungsten carbide bonded",
      "Anvils: manganese steel & ceramic-insert",
      "Cascade rings, distributor plates, wear shoes",
      "Made in India · OEM-equivalent dimensions",
      "Long wear-life formulations for high abrasion",
    ],
    tags: ["VSI", "Carbide", "Barmac", "Sandvik"],
  },
  {
    slug: "toggle-pins-half-rounds",
    name: "Toggle Pins & Half Rounds",
    short: "Crusher toggle pins, half rounds and toggle plates",
    image: `${IMG}/toggle-pins-half-rounds.jpg`,
    description:
      "EN-series forged & ground toggle pins, half rounds and toggle plates for jaw crushers. Hardened and tempered for shock load resistance.",
    specs: ["EN8 / EN24 / EN31 forged", "Hardened to 50-55 HRC", "Tight tolerance grinding", "All standard crusher sizes"],
    tags: ["Forging", "Wear Parts"],
  },
  {
    slug: "bearings",
    name: "Bearings — Imported & Indigenous",
    short: "SKF, FAG, NTN, Timken, NBC, ZKL, URB, FKRS",
    image: `${IMG}/bearings.jpg`,
    description:
      "Authorised stockists of premium imported and indigenous bearings — deep groove ball, taper roller, spherical roller, cylindrical roller, thrust and pillow blocks. Genuine, traceable, with manufacturer warranty.",
    specs: ["Brands: SKF, FAG, NTN, Timken, NBC, ZKL, URB, FKRS", "Types: DGBB, TRB, SRB, CRB, Thrust, Plummer", "Bore: 10 mm – 500 mm", "Genuine packaging"],
    tags: ["SKF", "FAG", "NTN", "Timken"],
  },
  {
    slug: "v-belts",
    name: "V-Belts (Multi-Brand)",
    short: "Fenner, PIX, KIE-Powerdrive, OMFA, Endura — all sections",
    image: `${IMG}/v-belts.jpg`,
    description:
      "Wrapped, raw-edge cogged and banded V-belts in all classical (A, B, C, D, E) and narrow (SPZ, SPA, SPB, SPC) sections. Heat & oil resistant compounds for crushers, blowers and machine tools.",
    specs: ["Sections: A, B, C, D, E, SPZ-SPC", "Lengths: up to 8000 mm", "Wrapped & RE-cogged", "Anti-static / oil & heat resistant"],
    tags: ["Fenner", "PIX", "KIE", "OMFA"],
  },
  {
    slug: "gear-boxes",
    name: "Gear Boxes — SMSR / Helical / Worm",
    short: "KIE-Powerdrive shaft-mounted, helical and worm gear boxes",
    image: `${IMG}/gear-boxes.jpg`,
    images: [
      `${IMG}/gear-boxes.jpg`,
      `${IMG}/gb-comet-smsr-1.jpg`,
      `${IMG}/gb-smsr-exploded.png`,
      `${IMG}/gb-kie-smsr.jpg`,
      `${IMG}/gb-kie-main.jpg`,
      `${IMG}/gb-kie-1.jpg`,
      `${IMG}/gb-kie-2.jpg`,
      `${IMG}/gb-kie-3.jpg`,
      `${IMG}/gb-kie-4.jpg`,
    ],
    description:
      "Shaft-mounted speed reducers (SMSR), inline helical, parallel-shaft and worm reduction gear boxes in cast-iron housing — supplied to crusher plants, conveyor systems, asphalt and road-construction machinery, cement and mining industries. All gears are precision-cut from high-grade alloy steel for higher efficiency, longer gear and bearing life. Each unit ships with corrosion-resistant torque arm, double-lip oil seals, hub covers and puller ring as standard accessories.",
    specs: [
      "Ratios: 5:1 to 80:1 (SMSR)",
      "Capacity: 0.5 HP – 200 HP",
      "Easy-mount in all positions, low noise & low maintenance",
      "Alloy-steel cut & ground gears, double-lip oil seals",
      "Backstop, torque arm & puller ring — standard accessories",
      "IS-7403 design",
    ],
    tags: ["KIE-Powerdrive", "SMSR", "Helical", "Worm"],
  },
  {
    slug: "motors",
    name: "Electric Motors — 1 HP to 200 HP",
    short: "Three-phase TEFC squirrel-cage induction motors",
    image: `${IMG}/motors.jpg`,
    description:
      "IE2 / IE3 efficiency three-phase induction motors in foot, flange and combined mounting. Built for continuous duty in dusty, vibration-prone industrial environments.",
    specs: ["Range: 1 HP to 200 HP", "Frame: 63 to 315", "Poles: 2 / 4 / 6 / 8", "Efficiency: IE2 / IE3", "IP-55 protection"],
    tags: ["TEFC", "IE3"],
  },
  {
    slug: "vibro-motors",
    name: "Vibro Motors",
    short: "Unbalanced electric vibrator motors for screens & feeders",
    image: `${IMG}/vibro-motors.jpg`,
    description:
      "Heavy-duty unbalanced vibrator motors for vibrating screens, grizzly feeders, hoppers and material flow aids. Adjustable centrifugal force with twin counterweights.",
    specs: ["Force: 100 kgf to 12000 kgf", "Poles: 2 / 4 / 6", "IP-65 / IP-66", "Heavy-duty bearings"],
    tags: ["Screens", "Feeders"],
  },
  {
    slug: "wire-mesh",
    name: "Crusher Wire Mesh & Piano Mesh",
    short: "Woven & welded screening media",
    image: `${IMG}/wire-mesh.jpg`,
    description:
      "Woven crimped wire mesh, self-cleaning piano wire mesh and harp screens for vibrating screens. High-tensile spring steel for maximum throughput and screen life.",
    specs: ["Aperture: 1 mm – 100 mm", "Wire: 1.6 mm – 12 mm", "Material: 65Mn / EN42 spring steel", "Hooked / flat ends"],
    tags: ["Screening", "Spring Steel"],
  },
  {
    slug: "diamond-rubber-lagging",
    name: "Diamond Rubber Lagging Sheets",
    short: "Pre-moulded diamond / herringbone lagging rubber",
    image: `${IMG}/diamond-rubber-lagging.jpg`,
    description:
      "Cold-bond and hot-vulcanised diamond grooved rubber lagging sheets for drive pulleys. Higher friction coefficient ensures slip-free belt drive and longer belt cover life.",
    specs: ["Thickness: 8 / 10 / 12 / 15 mm", "Pattern: Diamond / Herringbone", "Ceramic embedded option", "Hot vulcanising / cold bonding"],
    tags: ["Pulley", "Lagging"],
  },
  {
    slug: "oil-seals",
    name: "Oil Seals — VITON & Rajhans",
    short: "VITON, NBR, silicone rotary oil seals",
    image: `${IMG}/oil-seals.jpg`,
    description:
      "Premium rotary shaft oil seals from Rajhans and imported VITON brands. Single & double-lip, dust-lipped, metal-cased — for gear boxes, motors, pumps and crushers.",
    specs: ["Material: NBR / VITON / Silicone", "Type: TC / TB / SC / VC", "Bore: 6 mm – 400 mm", "Temperature: -30°C to 200°C"],
    tags: ["VITON", "Rajhans"],
  },
  {
    slug: "gaskets-orings",
    name: "Gaskets & O-Rings",
    short: "Neoprene & PU O-rings, custom gaskets",
    image: `${IMG}/gaskets-orings.jpg`,
    description:
      "Standard and custom-cut gaskets in neoprene, NBR, EPDM, PTFE, CAF and graphite. Polyurethane (PU) and neoprene O-rings — metric and inch sizes from stock.",
    specs: ["Neoprene / NBR / EPDM / PTFE / PU", "Sheet: 1 mm – 10 mm thick", "O-rings: BS-1806 / metric", "Custom die-cut gaskets"],
    tags: ["Sealing"],
  },
  {
    slug: "couplings",
    name: "Couplings — All Types",
    short: "Pin-bush, gear, jaw, tyre, fluid & flexible couplings",
    image: `${IMG}/couplings.jpg`,
    description:
      "Complete range of mechanical power-transmission couplings — pin-bush, gear, tyre, jaw, fluid (with delay chamber) and rigid flange couplings.",
    specs: ["Pin-bush, Gear, Tyre, Jaw, Fluid", "Bore: 14 mm – 250 mm", "Torque: up to 100,000 Nm", "OEM compatible"],
    tags: ["Drive", "Power Transmission"],
  },
  {
    slug: "hanging-magnets",
    name: "Hanging Magnets (KIE-Powerdrive)",
    short: "Suspended electromagnets & permanent magnets for crushers",
    image: `${IMG}/hanging-magnets.jpg`,
    description:
      "Heavy-duty hanging electromagnets and permanent magnetic separators for crusher conveyors. Removes tramp iron, protects crushers and screens from damage.",
    specs: ["Models: HMP / HME 100 to 1500", "Belt width: 500 – 1800 mm", "Suspension height: up to 400 mm", "Self / manual cleaning"],
    tags: ["KIE-Powerdrive", "Safety"],
  },
  {
    slug: "fenner-spares",
    name: "Fenner Gear Box Spares",
    short: "Genuine Fenner gear & shaft assemblies",
    image: `${IMG}/fenner-spares.jpg`,
    description:
      "Fenner spares — gears, pinions, input/output shafts, bearings, oil seals, gaskets and torque arms for SMSR and helical gear boxes.",
    specs: ["Genuine Fenner parts", "All SMSR / helical sizes", "Same-day dispatch"],
    tags: ["Fenner"],
  },
  {
    slug: "taper-pulleys-bushes",
    name: "Taper Lock Pulleys & Bushes",
    short: "V & timing pulleys with taper lock bushes",
    image: `${IMG}/taper-pulleys-bushes.jpg`,
    description:
      "Taper-lock pulleys (V-belt and timing) with matching taper-lock bushes for quick mounting and removal. Cast iron and ductile iron, balanced.",
    specs: ["Taper bushes: 1008 to 5050", "Sections: SPZ / SPA / SPB / SPC", "Multi-groove options", "Cast iron / DI"],
    tags: ["Pulleys", "Bushes"],
  },
  {
    slug: "trolley-wheels",
    name: "Trolley Wheels & Castors",
    short: "Heavy-duty material handling wheels",
    image: `${IMG}/trolley-wheels.jpg`,
    description:
      "Cast iron, MS, PU and rubber-tyred trolley wheels and castors for material handling trolleys, hand-pallet trucks and platforms. Sealed bearings for long life.",
    specs: ["Diameter: 100 – 400 mm", "Load: up to 2000 kg/wheel", "Material: CI / MS / PU / Nylon", "Swivel & fixed castors"],
    tags: ["Material Handling"],
  },
];

export const GALLERY = [
  "/images/products/conveyor-belts.jpg",
  "/images/products/idler-rollers.jpg",
  "/images/products/bearings.jpg",
  "/images/products/gear-boxes.jpg",
  "/images/products/jaw-plates-cone-mantles.jpg",
  "/images/products/cone-mantles.jpg",
  "/images/products/motors.jpg",
  "/images/products/vibro-motors.jpg",
  "/images/products/couplings.jpg",
  "/images/products/hanging-magnets.jpg",
  "/images/gallery/1-110620164G047.jpg",
  "/images/gallery/1-110620164G449.jpg",
  "/images/gallery/ice-trade-conveyor-belt-winders-1418323z3.jpg",
  "/images/gallery/conv-2.jpg",
  "/images/gallery/conv-3.jpg",
  "/images/gallery/cb-1.jpg",
  "/images/gallery/gb-1.jpg",
  "/images/gallery/gb-2.jpg",
  "/images/gallery/banner.jpg",
  "/images/gallery/lagging-2.jpg",
  "/images/gallery/magnetic-2.jpg",
  "/images/gallery/sprocket.jpg",
];

export const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/23338a87-42db-4e7c-abc4-65910de60902/images/46d52104746b770377d1f8af18487dd44abb25a6560622492fbfd1c837185840.png";
